/* eslint-disable */
// https://react-bootstrap-table.github.io/react-bootstrap-table2/
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
// https://www.npmjs.com/package/react-bootstrap-table-next
import React, { useState, useRef, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { cloneDeep, isEqual } from 'lodash';
import { createRoot } from 'react-dom/client';
import { ClickAwayListener } from '@mui/material';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Search from './Search';
import PaginationLinks from './PaginationLinks';

import './datatable.scss';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const defaultConfig = {
	showPagination: true,
	showFilter: true,
	showLeftButton: false,
	leftButtonClassName: '',
	leftButtonStyle: {},
	leftButtonIcon: '',
	leftButtonText: '',
	tableMarginLess: false,
	defaultSort: [
		{
			dataField: 'id',
			order: 'asc',
		},
	],
	showAllData: false,
	footer: false,
	footerStyle: '',
	headerFilter: false,
	isTableEdit: false,
	blurToSave: false,
};

const DTable = ({
	data = [],
	config: propsConfig = {},
	columns = [],
	onInteraction,
	loading = false,
	remote = false,
	totalDataSize = 0,
	contextMenus = [],
	onContextMenuItemClick,
	onLeftButtonClick,
	wrapperClassName = '',
	className = '',
	showOrdering = true,
	individualContextMenus = false,
	isSelect = false,
	selectMode = 'checkbox',
	selectPosition = 'left',
	onSelect,
	onSelectAll,
	locale,
	onColumnToggle,
}) => {
	const [initialData, setInitialData] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [sizePerPage, setSizePerPage] = useState(10);
	const [searchValue, setSearchValue] = useState('');
	const [open, setOpen] = useState(false);
	const [allCheckValue, setAllCheckValue] = useState(false);
	const config = { ...defaultConfig, ...propsConfig };
	const tableRef = useRef(null);
	const anchorRef = useRef(null);
	const excelRef = useRef(null);
	const cmWrapperRoot = useRef(null);

	const unMountContextMenus = () => {
		const wrapper = getWrapper();
		if (wrapper) {
			cmWrapperRoot.current?.unmount()
		}
	};

	useEffect(() => {
		if (!isEqual(data, initialData)) {
			setInitialData(data);
		}
		if (config.showAllData) {
			setSizePerPage(data.length + 10);
		}
		return () => {
			unMountContextMenus();
		};
	}, [data]);

	const pgOptions = {
		custom: true,
		paginationSize: 5,
		sizePerPageList: [10, 25, 50, 100],
		totalSize: remote ? totalDataSize : data && data.length > 0 ? data.length : 0,
		page: pageNumber,
		sizePerPage,
	};

	const getUserInteraction = (object, searchValue) => {
		let tableState = {};
		if (tableRef.current) {
			const { page, sizePerPage: pageSize, sortField, sortOrder } = tableRef.current.getNewestState();
			tableState = {
				page: page || 1,
				pageSize,
				sort: sortField,
				order: sortOrder,
				search: searchValue,
				filter: object,
			};
		}

		onInteraction?.({
			...tableState,
			...object,
		});
	};

	const handleTableChange = (type, newState) => {
		switch (type) {
			case 'filter': {
				break;
			}
			case 'pagination': {
				if (newState.page !== pageNumber) {
					setPageNumber(newState.page);
				}
				if (newState.sizePerPage !== sizePerPage) {
					setSizePerPage(newState.sizePerPage);
					// getUserInteraction({ pageSize: newState.sizePerPage });
				}
				getUserInteraction({
					page: newState.page ? newState.page : 1,
					pageSize: newState.sizePerPage,
				}, searchValue);
				break;
			}
			case 'sort': {
				getUserInteraction({
					sort: newState.sortField,
					order: newState.sortOrder,
				}, searchValue);
				break;
			}
			case 'cellEdit': {
				break;
			}
			default: {
				break;
			}
		}
	};

	const getNoDataText = () => {
		if (loading) {
			return '<div className="spinner-border text-primary" />';
		}

		return (
			<div style={{ textAlign: "center" }}>{'Жагсаалт хоосон байна'}</div>
		);
	};

	const handleSearch = () => {
		if (remote) {
			getUserInteraction({}, searchValue);
		}
	};

	const getTableData = () => {
		if (remote) {
			return data;
		}

		let clone = [];
		if (Array.isArray(initialData)) {
			clone = cloneDeep(initialData);
		} else {
			clone = cloneDeep(Object.values(initialData));
		}

		if (searchValue) {
			const val = searchValue.toLowerCase();
			return clone.filter((record) => {
				for (const column of columns) {
					if (record.hasOwnProperty(column.dataField)) {
						/// ignoring number type for now!!!.
						if (typeof record[column.dataField] === 'string' && record[column.dataField].toLowerCase().includes(val)) {
							return true;
						}
					}
				}
				return false;
			});
		}

		return clone;
	};

	const onContextMenu = (e, row) => {
		e.preventDefault();
		unMountContextMenus();

		let availableContextMenus = [];

		if (individualContextMenus) {
			if (contextMenus.length && row.contextMenuKeys?.length) {
				for (const menu of contextMenus) {
					if (row.contextMenuKeys.includes(menu.key)) {
						availableContextMenus.push(menu);
					}
				}
			}
		} else {
			availableContextMenus = contextMenus;
		}

		if (availableContextMenus.length) {
			const wrapper = getWrapper();
			const menu = (
				<ClickAwayListener onClickAway={unMountContextMenus}>
					<div className="dt-cm-wrapper" style={{ top: e.pageY, left: e.pageX }}>
						{availableContextMenus.map((menu) => {
							return (
								<div
									className="dt-cm-item"
									onClick={(event) => {
										event.stopPropagation();
										unMountContextMenus();
										onContextMenuItemClick?.(row.id, menu.key, row, event);
									}}
									key={menu.key}
								>
									<div>{menu.icon ? menu.icon : null}</div>
									<span className='grey-color'>{menu.title}</span>
								</div>
							);
						})}
					</div>
				</ClickAwayListener>
			);
			cmWrapperRoot.current = createRoot(wrapper)
			if (cmWrapperRoot?.current) {
				cmWrapperRoot.current?.render(menu)
			}
		}
	};

	const getWrapper = () => {
		const id = 'datatable-contextmenu-wrapper';
		const cmWrapper = document.getElementById(id);
		if (cmWrapper) {
			return cmWrapper;
		} else {
			const cmWrapper = document.createElement('div');
			cmWrapper.id = id;
			document.body.appendChild(cmWrapper);
			return cmWrapper;
		}
	};

	const getColumns = (isToolkit = false) => {
		const cols = [];

		if (showOrdering) {
			if (config.footer) {
				cols.push({
					isDummyField: true,
					text: '№',
					dataField: 'dt-row-order-number',
					formatter(cell, row, rowIndex) {
						return rowIndex + 1;
					},
					csvFormatter(cell, row, rowIndex) {
						return rowIndex + 1;
					},
					headerStyle: () => {
						return {
							width: 50,
						};
					},
					headerAlign: 'left',
					style: {
						textAlign: 'left',
						verticalAlign: 'middle',
					},
					footer: '',
					footerStyle: config.footerStyle,
				});
			} else {
				cols.push({
					isDummyField: true,
					text: '№',
					dataField: 'dt-row-order-number',
					formatter(cell, row, rowIndex) {
						return rowIndex + 1;
					},
					csvFormatter(cell, row, rowIndex) {
						return rowIndex + 1;
					},
					headerStyle: () => {
						return {
							width: 50,
						};
					},
					headerAlign: 'left',
					style: {
						textAlign: 'left',
						verticalAlign: 'middle',
					},
				});
			}
		}

		for (const col of columns) {
			if (!isToolkit && col.colVisible === false) {
				//
			} else {
				if (config.headerFilter) {
					if (col.filterDisable) {
						cols.push({
							...col,
						});
					} else {
						cols.push({
							...col,
							filter: textFilter({
								placeholder: ' ',
								onFilter: (filterValue) => {
									getUserInteraction({
										filter: filterValue,
										field: col.dataField,
									}, searchValue);
								},
							}),
						});
					}
				} else {
					if (config.columnButton) {
						if (col.colVisible === true) {
							cols.push({
								...col,
							});
						}
					} else {
						cols.push({
							...col,
						});
					}
				}
			}
		}

		if (!config.footer) {
			if (cols && cols.length > 0) {
				for (let i = 0; i < cols.length; i++) {
					if (cols && cols[i].footer) {
						cols[i].footer = false;
					}
				}
			}
		} else if (cols && cols.length > 0) {
			for (let i = 0; i < cols.length; i++) {
				if (cols) {
					cols[i].footerStyle = config.footerStyle;
					if (cols[i].footerType == 'sum') {
						let sum = 0;
						if (data && data.length > 0) {
							for (let c = 0; c < data.length; c++) {
								let amount = data[c][cols[i].dataField];
								if (amount) {
									if (!Number.isInteger(amount)) {
										const specialChars = '\'"\\,./`';
										const isSpecChar = checkSpecialChars(specialChars, amount);

										if (isSpecChar) {
											amount = amount.replaceAll("'", '');
										}
									}

									sum += parseInt(amount);
								}
							}
						}
						cols[i].footer = sum || '0';
					}
				}
			}
		}

		return cols;
	};

	const getAllColumns = (isToolkit = false) => {
		const cols = [];

		if (showOrdering) {
			cols.push({
				isDummyField: true,
				text: '№',
				dataField: 'dt-row-order-number',
				formatter(cell, row, rowIndex) {
					return rowIndex + 1;
				},
				csvFormatter(cell, row, rowIndex) {
					return rowIndex + 1;
				},
				headerStyle: () => {
					return {
						width: 50,
					};
				},
				headerAlign: 'center',
				style: {
					textAlign: 'right',
				},
			});
		}

		for (const col of columns) {
			if (!isToolkit && col.colVisible === false) {
				//
			} else {
				cols.push({
					...col,
				});
			}
		}

		return cols;
	};

	const checkSpecialChars = (specialChars, string) => {
		for (let i = 0; i < specialChars.length; i++) {
			if (string.indexOf(specialChars[i]) > -1) {
				return true;
			}
		}
		return false;
	};

	const handlerOnSelect = (row, isSelect, rowIndex, e) => {
		onSelect?.(row, isSelect, rowIndex, e);
	};

	const handlerOnSelectAll = (isSelect, rows, e) => {
		onSelectAll?.(isSelect, rows, e);
	};

	const selectRow = {
		mode: selectMode,
		clickToSelect: true,
		hideSelectColumn: !isSelect,
		selectColumnPosition: selectPosition,
		classes: 'dtable-selected',
		style: { backgroundColor: 'rgba(244, 81, 107, 0.5)' },
		onSelect: (row, isSelect, rowIndex, e) => {
			handlerOnSelect(row, isSelect, rowIndex, e);
		},
		onSelectAll: (isSelect, rows, e) => {
			handlerOnSelectAll(isSelect, rows, e);
		},
		clickToEdit: config.isTableEdit,
	};

	const cellEdit = cellEditFactory({
		mode: 'click',
		blurToSave: config.blurToSave,
	});

	const handleColumnsOpen = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleColumnsClose = () => {
		setOpen(false);
	};

	return (
		<PaginationProvider pagination={paginationFactory(pgOptions)}>
			{({ paginationProps, paginationTableProps }) => (
				<div style={config.tableMarginLess ? {} : { marginBottom: 15, marginTop: 15 }}>
					<DndProvider backend={HTML5Backend}>
						<ToolkitProvider
							keyField="id"
							data={getTableData()}
							columns={getAllColumns(true)}
							exportCSV={{
								fileName: config.excelFileName?.replaceAll(/ /g, "_") + '.xlsx',
								exportAll: false,
								blobType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
							}}
							csvExport={true}
							columnToggle
						>
							{
								props => (
									<div>
										<div style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											marginBottom: 10,
										}}>
											<SizePerPageDropdownStandalone
												className={`custom-size-per-page ${!config.showPagination ? 'height-0' : ''}`}
												{...paginationProps}
												sizePerPage={paginationProps.sizePerPage}
												hidden={!config.showPagination}
											/>
											{
												config.showLeftButton
													?
													<button
														className={config.leftButtonClassName}
														style={config.leftButtonStyle}
														onClick={onLeftButtonClick}
													>
														{
															config.leftButtonIcon
																?
																<>
																	{config.leftButtonIcon}
																	<span className='ml-2'>
																		{config.leftButtonText}
																	</span>
																</>
																:
																config.leftButtonText
														}
													</button>
													: null
											}
											<div className="w-100 text-right">
												{
													config.columnButton
														?
														<div
															style={{
																display: 'contents',
															}}
														>
															<CustomToggleList
																{...props.columnToggleProps}
																anchorRef={anchorRef}
																open={open}
																handleToggle={handleColumnsOpen}
																handleClose={handleColumnsClose}
																onColToggle={onColumnToggle}
																csvExport={true}
															/>
														</div>
														: null
												}
											</div>
											{
												config.showFilter && (
													<Search
														value={searchValue}
														onSearch={handleSearch}
														setter={value => {
															setSearchValue(value)
															if (!value) {
																getUserInteraction({}, value)
															}
														}}
														onSubmit={(query) => {
															if (query && query.length > 0) {
																handleSearch()
															}
														}}
														locale={locale}
													/>
												)
											}
										</div>
										<BootstrapTable
											keyField="id"
											id='table-to-xls'
											ref={tableRef}
											{...props.baseProps}
											{...paginationTableProps}
											striped
											remote={remote}
											wrapperClasses={`table-responsive ${wrapperClassName}`}
											classes={`table custom-dt ${className}`}
											data={getTableData()}
											onTableChange={handleTableChange}
											noDataIndication={getNoDataText}
											defaultSorted={config.defaultSort}
											rowEvents={{ onContextMenu }}
											rowClasses={row => {
												return `dt-row-${row.id}`;
											}}
											selectRow={selectRow}
											filter={filterFactory()}
											cellEdit={cellEdit}
											columns={getColumns()}
											bootstrap4
										/>
									</div>
								)
							}
						</ToolkitProvider>
					</DndProvider>
					{config.showPagination && (
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<div style={{ flex: 1 }}>
								<div style={{ color: '#62646e', fontSize: '14px' }}> Нийт {
									paginationProps.totalSize
								} илэрцийн {
										paginationProps.page == 1
											?
											1
											:
											(paginationProps.sizePerPage + 1)
									}-с { }
									{
										paginationProps.totalSize < (paginationProps.sizePerPage * paginationProps.page)
											?
											paginationProps.totalSize
											:
											paginationProps.sizePerPage * paginationProps.page
									}-г харуулж байна.
								</div>
								{/*<div style={{color: '#000', fontWeight: 500}}>{`${translations(locale).action.total} ${paginationProps.totalSize} ${translations(locale).action.value}`}</div>*/}
							</div>
							<PaginationLinks paginationProps={paginationProps} />
						</div>
					)}
				</div>
			)}
		</PaginationProvider>
	);
};

export default DTable;
